import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import DepthBonusSkillNode from "./DepthBonusSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";

export default class DepthBonusSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     */
    constructor(totals, values, mineDamageLogic) {
        super(SkillIds.DEPTH_BONUS);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 20;
        let cost = 20;
        let purchaseIndex = 0;

        const depthBonus1 = this.addNode(new DepthBonusSkillNode('depthBonus1', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus2 = this.addNode(new DepthBonusSkillNode('depthBonus2', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus3 = this.addNode(new DepthBonusSkillNode('depthBonus3', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus4 = this.addNode(new DepthBonusSkillNode('depthBonus4', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus5 = this.addNode(new DepthBonusSkillNode('depthBonus5', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus6 = this.addNode(new DepthBonusSkillNode('depthBonus6', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus7 = this.addNode(new DepthBonusSkillNode('depthBonus7', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus8 = this.addNode(new DepthBonusSkillNode('depthBonus8', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus9 = this.addNode(new DepthBonusSkillNode('depthBonus9', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus10 = this.addNode(new DepthBonusSkillNode('depthBonus10', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus11 = this.addNode(new DepthBonusSkillNode('depthBonus11', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus12 = this.addNode(new DepthBonusSkillNode('depthBonus12', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus13 = this.addNode(new DepthBonusSkillNode('depthBonus13', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus14 = this.addNode(new DepthBonusSkillNode('depthBonus14', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus15 = this.addNode(new DepthBonusSkillNode('depthBonus15', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus16 = this.addNode(new DepthBonusSkillNode('depthBonus16', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus17 = this.addNode(new DepthBonusSkillNode('depthBonus17', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus18 = this.addNode(new DepthBonusSkillNode('depthBonus18', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus19 = this.addNode(new DepthBonusSkillNode('depthBonus19', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus20 = this.addNode(new DepthBonusSkillNode('depthBonus20', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const depthBonus21 = this.addNode(new DepthBonusSkillNode('depthBonus21', 
            totals, Images.currency.depth, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));
        


        depthBonus1.addChildNode(depthBonus2);
        depthBonus2.addChildNode(depthBonus3);
        depthBonus3.addChildNode(depthBonus4);
        depthBonus4.addChildNode(depthBonus5);
        depthBonus5.addChildNode(depthBonus6);
        depthBonus6.addChildNode(depthBonus7);
        depthBonus7.addChildNode(depthBonus8);

        depthBonus8.addChildNode(depthBonus9);
        depthBonus9.addChildNode(depthBonus10);
        depthBonus10.addChildNode(depthBonus11);
        depthBonus11.addChildNode(depthBonus12);
        depthBonus12.addChildNode(depthBonus13);
        depthBonus13.addChildNode(depthBonus14);
        depthBonus14.addChildNode(depthBonus15);

        depthBonus15.addChildNode(depthBonus16);
        depthBonus16.addChildNode(depthBonus17);
        depthBonus17.addChildNode(depthBonus18);
        depthBonus18.addChildNode(depthBonus19);
        depthBonus19.addChildNode(depthBonus20);
        depthBonus20.addChildNode(depthBonus21);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = 4;
        const startY = -7;

        depthBonus1.setPosition(startX, startY);
        depthBonus2.setPosition(startX + 1, startY);
        depthBonus3.setPosition(startX + 2, startY);
        depthBonus4.setPosition(startX + 3, startY);
        depthBonus5.setPosition(startX + 4, startY);
        depthBonus6.setPosition(startX + 5, startY);
        depthBonus7.setPosition(startX + 6, startY);

        depthBonus8.setPosition(startX + 6, startY - 1);
        depthBonus9.setPosition(startX + 5, startY - 1);
        depthBonus10.setPosition(startX + 4, startY - 1);
        depthBonus11.setPosition(startX + 3, startY - 1);
        depthBonus12.setPosition(startX + 2, startY - 1);
        depthBonus13.setPosition(startX + 1, startY - 1);
        depthBonus14.setPosition(startX, startY - 1);

        depthBonus15.setPosition(startX, startY - 2);
        depthBonus16.setPosition(startX + 1, startY - 2);
        depthBonus17.setPosition(startX + 2, startY - 2);
        depthBonus18.setPosition(startX + 3, startY - 2);
        depthBonus19.setPosition(startX + 4, startY - 2);
        depthBonus20.setPosition(startX + 5, startY - 2);
        depthBonus21.setPosition(startX + 6, startY - 2);

    }
    
}